module.exports = __webpack_public_path__ + "img/women_strong.2fe226d3.png";